import * as yup from "yup";
import { ExternalSection } from "components";
import { FieldSetHookForm, FieldSetInputProps } from "components/voc";
import { PolicyPanel } from "components/ca";
import React, { useEffect, useRef } from "react";
import { caApi, blockApiProps } from "apis";
import { useToast, useQueryString } from "hooks";
import { useLocation } from "react-router-dom";
import { useCookies } from "react-cookie";

const Policy = () => {
  const location = useLocation();
  const toast = useToast();

  const queryString = useQueryString(location.search);
  const blockQuery = queryString.json;
  const campaignId = blockQuery?.campaign_id;

  const [cookies, setCookies] = useCookies([campaignId]);
  const isAllow = cookies[campaignId] ? JSON.parse(cookies[campaignId]) : true;

  // useEffect(() => {
  //   toast.show(
  //     <>
  //       <p>
  //         <strong>debug</strong>
  //       </p>
  //       {(location.search && location.search.split("&").map((el, idx) => <p key={idx}>{el}</p>)) || "파라미터 없음"}
  //     </>
  //   );
  // }, []);

  const submitRef = useRef<HTMLButtonElement>(null);

  const handleSubmit = async (data: { is_allow: string }) => {
    const expires = new Date();
    expires.setFullYear(expires.getFullYear() + 1);
    setCookies(campaignId, JSON.parse(data.is_allow), { path: "/", expires: expires });

    const blockParams = {
      "SKPAd-UUID": blockQuery["SKPAd-UUID"],
      campaign_id: Number(blockQuery.campaign_id),
      campaign_name: blockQuery.campaign_name,
      device_id: Number(blockQuery.device_id),
      vd_id: blockQuery.vd_id,
      ifa: blockQuery.ifa,
      ifv: blockQuery.ifv,
      app_id: Number(blockQuery.app_id),
      unit_id: Number(blockQuery.unit_id),
      adnetwork_campaign_id: blockQuery.adnetwork_campaign_id,
    };

    const params: blockApiProps = {
      ...blockParams,
      is_allow: JSON.parse(data.is_allow),
    };

    try {
      await caApi.block(params);
    } catch (err) {
      console.log(err);
    }
  };

  const handleChange = (e: React.FormEvent<HTMLFormElement>) => {
    submitRef.current?.click();
  };

  const field: FieldSetInputProps[] = [
    {
      formGroup: {
        formType: "radio",
        form: [
          {
            type: "radio",
            labelText: "허용",
            name: "is_allow",
            id: "qacodeRadioAgree",
            valid: yup.number(),
            value: "true",
            defaultChecked: isAllow ? true : false,
            className: "uncheck-disable",
          },
          {
            type: "radio",
            labelText: "차단",
            name: "is_allow",
            id: "qacodeRadioDisagree",
            value: "false",
            valid: yup.number(),
            defaultChecked: !isAllow ? true : false,
            className: "uncheck-disable",
          },
        ],
      },
    },
  ];

  const policyItems = [
    { title: "행태정보 수집 및 처리 사업자", detail: "SK Planet" },
    {
      title: "수집하는 행태정보 항목",
      detail: (
        <ul>
          <li>광고식별자</li>
          <li>이용자의 서비스 내 방문 기록 및 검색기록</li>
          <li>이용자의 앱 사용이력</li>
        </ul>
      ),
    },
    { title: "행태정보 수집 방법", detail: "이용자가 서비스를 이용하는 과정에서 자동 수집 및 전송" },
    { title: "행태정보 수집 목적", detail: "이용자 관심 기반의 맞춤형 광고 제공" },
    { title: "행태정보 보유 • 이용 기간 및 이후 정보 처리 방법", detail: "수집한 행태정보는 4개월 보관 후 안전하게 파기합니다" },
    {
      title: "이용자 통제권 행사 방법",
      detail: (
        <>
          <div className="item_control_detail">
            <strong className="txt_title">
              <em className="txt_em">웹 브라우저</em>에서 광고를 차단하는 경우
            </strong>
            <ul className="list_web">
              <li className="item">
                Chrome{" "}
                <a href="https://support.google.com/chrome/answer/95647?hl=ko" className="btn_detail" target="_blank" rel="noreferrer">
                  자세히 보기
                </a>
              </li>
              <li className="item">
                Edge{" "}
                <a
                  href="https://support.microsoft.com/ko-kr/microsoft-edge/microsoft-edge%EC%97%90%EC%84%9C-%EC%BF%A0%ED%82%A4-%EC%82%AD%EC%A0%9C-63947406-40ac-c3b8-57b9-2a946a29ae09"
                  className="btn_detail"
                  target="_blank"
                  rel="noreferrer"
                >
                  자세히 보기
                </a>
              </li>
              <li className="item">
                Safari{" "}
                <a href="https://support.apple.com/ko-kr/guide/safari/sfri11471/mac" className="btn_detail" target="_blank" rel="noreferrer">
                  자세히 보기
                </a>
              </li>
            </ul>
          </div>
          <div className="item_control_detail">
            <strong className="txt_title">
              <em className="txt_em">앱</em>에서 광고를 차단하는 경우
            </strong>
            <ul className="list_app">
              <li className="item">
                <strong className="txt_subtitle">Android</strong>
                <p className="txt">홈&gt;설정&gt;구글&gt;광고&gt;광고 ID 삭제</p>
                <a href="https://support.google.com/googleplay/answer/3405269?hl=ko" className="btn_detail" target="_blank" rel="noreferrer">
                  자세히 보기
                </a>
              </li>
              <li className="item">
                <strong className="txt_subtitle">iOS</strong>
                <p className="txt">홈&gt;설정&gt;개인 정보 보호&gt;추적&gt;앱이 추적을 요청하도록 허용(OFF)</p>
                <a href="https://support.apple.com/ko-kr/HT212025" className="btn_detail" target="_blank" rel="noreferrer">
                  자세히 보기
                </a>
              </li>
              <li className="item" style={{ display: campaignId ? "" : "none" }}>
                <strong className="txt_subtitle">맞춤형 광고 허용 여부 선택</strong>
                <FieldSetHookForm id="block-form" inputs={field} showSubmit={false} onSubmit={handleSubmit} onChange={handleChange} legend={""} />
                <button type="submit" form="block-form" style={{ display: "none" }} ref={submitRef}></button>
                <ul className="list_noti">
                  <li className="txt_red">Planet AD의 맞춤형 광고를 차단하는 경우, 참여할 수 있는 리워드형 광고가 노출되지 않을 수 있습니다.</li>
                  <li>"차단" 옵션을 선택하여도, 광고 식별자를 재 설정하는 경우 '허용' 상태로 변경되어 다시 맞춤형 광고가 노출될 수 있습니다.</li>
                </ul>
              </li>
            </ul>
          </div>
        </>
      ),
    },
    {
      title: "이용자 피해구제 방법",
      detail: (
        <>
          E-mail :{" "}
          <a href="mailto:planetad_qna@skplanet.com" className="txt_email">
            planetad_qna@skplanet.com
          </a>
        </>
      ),
    },
  ];
  return (
    <>
      <ExternalSection className="page_policy">
        <div className="page_top_header">
          <h2 className="txt_title">온라인 맞춤형 광고 처리 방침</h2>
          <p className="txt_desc">SK 플래닛(주)은 안전한 온라인 맞춤형 광고 제공을 위해 아래와 같이 행태정보를 처리하고 있습니다.</p>
        </div>
        <PolicyPanel items={policyItems} key={isAllow} />
        <toast.container />
      </ExternalSection>
    </>
  );
};

export default Policy;
